module.exports = __webpack_public_path__ + "img/poster-image-01.1bcf7492.jpg";